var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ModuleValueGeneral, SchemaModuleGeneral } from './module-general';
import * as rawJSONSchemaModuleSurgerySpinal from '../../schemas/module-surgery-spinal.json';
var ModuleValueSurgerySpinal = (function (_super) {
    __extends(ModuleValueSurgerySpinal, _super);
    function ModuleValueSurgerySpinal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ModuleValueSurgerySpinal;
}(ModuleValueGeneral));
var SchemaModuleSurgerySpinal = (function (_super) {
    __extends(SchemaModuleSurgerySpinal, _super);
    function SchemaModuleSurgerySpinal() {
        var _this = _super.call(this) || this;
        _this.loadSchema(rawJSONSchemaModuleSurgerySpinal);
        return _this;
    }
    SchemaModuleSurgerySpinal.prototype.hook = function (form) {
        _super.prototype.hook.call(this, form);
    };
    return SchemaModuleSurgerySpinal;
}(SchemaModuleGeneral));
export { SchemaModuleSurgerySpinal };



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/forms/module-surgery-spinal.ts.pre-build-optimizer.js